import React from 'react';
import './ActionsButtons.css';

function ActionsButtons({
  text,
  onClick,
  type = 'button',
  showCancel = false,
  cancelText = 'Cancelar',
  onCancel = () => {},
  showSecondary = false,
  secondaryText = 'Secundário',
  onSecondaryClick = () => {},
  showTertiary = false,
  tertiaryText = 'Terciário',
  onTertiaryClick = () => {},
}) {
  return (
    <div className="btn-group">
      {showCancel && (
        <button className="btn-cancelar" type="button" onClick={onCancel}>
          {cancelText}
        </button>
      )}

      {showSecondary && (
        <button className="btn-secondary" type="button" onClick={onSecondaryClick}>
          {secondaryText}
        </button>
      )}

     {showTertiary && (
       <button className="btn-tertiary" type="button" onClick={onTertiaryClick}>
         {tertiaryText}
       </button>
     )}

      <button className="btn-primary" type={type} onClick={onClick}>
        {text}
      </button>
    </div>
  );
}

export default ActionsButtons;